// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610020904/js/" + chunkId + "." + {"44":"9a4437a5","225":"0a1fdcf6","481":"9053614f","486":"a566fa76","770":"b717ef46"}[chunkId] + ".0.8702712329275016.chunk.js";
};